// extracted by mini-css-extract-plugin
export default {"markdownPage":"About_markdownPage__5lpwD"};